import styled from 'styled-components';

export const Container = styled.div`
  padding-bottom: 1em;
  display: grid;
  gap: 1em;
  p,
  strong,
  h1,
  label {
    font-family: 'Inter', sans-serif;
  }
`;

export const Content = styled.div`
  background-color: #fff;
  padding: 1em;
  border-radius: 8;
`;

export const DescriptionHeader = styled.p`
  color: #000;
  font-size: 1em;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5em;

  strong {
    font-weight: bold;
  }
`;

export const Separator = styled.hr`
  height: 2px;
  background-color: #d9d6e8;
  border: 0;
  margin: 10px 0;
`;

export const TitleContent = styled.h1`
  font-size: 1.4em;
  font-weight: 700;
  color: #000;
  margin: 8px 0;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
`;

export const RadioWrapper = styled.div`
  padding-top: 8px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
